import React from "react";
import Box from "../SharedComponents/Box";
import SetupTittle from "../SharedComponents/SetupTittle";
import SetupContainer from "../SharedComponents/SetupContainer";
import CarrierPartnerPointManager from "./CarrierPartnerPointManager";

const CarrierPartnerPointSetup = () => {
  return (
    <SetupContainer>
      <Box top>
        <SetupTittle text="Point Names" />
        <p className="text-stone-600 mb-4">
          These describe what a carrier partner is doing, e.g. UK to BD or
          customer home to UK hub. They appear in the Carrier Partner dropdown.
        </p>
        <CarrierPartnerPointManager />
      </Box>
    </SetupContainer>
  );
};

export default CarrierPartnerPointSetup;
